/**
 * FPX Payment Method Icon Data URL
 *
 * FPX is Malaysia's real-time online payment platform that enables
 * customers to make online payments directly from their bank accounts.
 *
 * @module @one-payments/core/icons
 */

export const FPX_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/35hEmofKsxnjVV4zidB0Ir/00447c59f79d5c1e095f1354f6b909ce/FPX.svg';
